export const UTM_COOKIE_EXPIRATION_DAYS = 180;
export const UTM_COOKIE_SOURCE_KEY = "engine_utm_source";
export const UTM_COOKIE_MEDIUM_KEY = "engine_utm_medium";
export const UTM_COOKIE_CAMPAIGN_KEY = "engine_utm_campaign";
